meedy.controller('meedy.popupCalendarTermCancelController', ['$scope', '$state', '$mdDialog', '$timeout', 'meedy.termModel', 'term', 'applicationModel',
    function ($scope, $state, $mdDialog, $timeout, termModel, term, applicationModel) {

        function setData() {
            // isolated scope, needs these injected again
            $scope.Enum = Enum;
            $scope.Constant = Constant;

            $scope.term = term;

            $scope.cancelData  = {
                cancelReasons: [],
                cancelReason: null,
                cancelStatusDescription: null
            };

            $scope.forms = {};
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$watch(function () {
                return applicationModel.actionInProgress;
            }, function (newVal) {
                $scope.actionInProgress = newVal;
            });

            $scope.$on(Event.MEEDY.TERM.GET_STATUS_REASONS.SUCCESS, function (event, data) {
                var statusReasons = data;
                $scope.cancelData.cancelReasons = _.sortBy(statusReasons, ['orderNumber']);
            });
        }

        function setActions() {
            $scope.cancelAppointment = function () {
                $scope.forms.term.$setSubmitted();

                if ($scope.forms.term.$valid) {

                    termModel.cancelAppointment($scope.term.id, $scope.cancelData.cancelReason.id, $scope.cancelData.cancelStatusDescription);

                    var successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CANCEL_APPOINTMENT.SUCCESS, function (event, result) {
                        successWatcherDisabler();
                        errorWatcherDisabler();

                        $scope.forms.term.$setPristine();
                        $mdDialog.hide();
                    });

                    var errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CANCEL_APPOINTMENT.ERROR, function (event, error) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                    });
                }
            };

            $scope.ok = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {

        }

        function initialize() {
            termModel.getStatusReasons();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);